module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/16-e11f122e714802391a5bd3f1f26921fc.jpg";